module.exports = __webpack_public_path__ + "static/media/Trading_Up_Tablet_Banner_STAKE@1x.c53af19c.jpg";